// <editor-fold desc="Enumerations">

/**
 * Enumeration for RS232 power states
 * @readonly
 * @enum {string}
 */
const Rs232PowerState = {
    On: 'on',
    Off: 'off',
};
/**
 * Enumeration for RS232 mute states
 * @readonly
 * @enum {string}
 */
const Rs232MuteState = {
    Mute: 'mute',
    Unmute: 'unmute',
};
/**
 * Enumeration for RS232 video inputs
 * @readonly
 * @enum {string}
 */
const Rs232VideoInput = {
    VGA: 'VGA',
    DVI: 'DVI',
    SVideo: 'SVideo',
    Component: 'Component',
    HDMI: 'HDMI',
};

// </editor-fold>

/**
 * Thunk for throwing exceptions
 * @param failingCodeName
 * @returns {Function}
 * @protected
 */
function _throwNotImplementedException(failingCodeName) {
    return function () {
        throw new Error('`' + failingCodeName + '` not implemented');
    };
}

export { Rs232PowerState, Rs232MuteState, Rs232VideoInput, _throwNotImplementedException };
